import { caseInsensitiveSort } from '@/lib/sort';
import type { Milestone, State } from './types';

export type Mutation =
  | { type: 'setMilestones'; data: Milestone[] }
  | { type: 'addMilestone'; data: Milestone }
  | { type: 'dismissMilestone'; id: string }
  | { type: 'replaceMilestone'; data: Milestone };

export function reducer(state: State, action: Mutation): State {
  switch (action.type) {
    case 'setMilestones':
      return setMilestones(state, action);
    case 'replaceMilestone':
      return replaceMilestone(state, action);
    case 'addMilestone':
      return addMilestone(state, action);
    case 'dismissMilestone':
      return dismissMilestone(state, action);
    default:
      return state;
  }
}

function setMilestones(_state: State, { data }: { data: Milestone[] }): State {
  const all = (data || []).sort(
    caseInsensitiveSort(['data.occurred_on', 'data.milestone_id']),
  );

  return {
    loaded: true,
    list: all,
  };
}

function addMilestone(state: State, { data }: { data: Milestone }): State {
  const newList = [...state.list, data];

  return {
    ...state,
    list: newList.sort(
      caseInsensitiveSort(['data.occurred_on', 'data.milestone_id']),
    ),
  };
}

function dismissMilestone(state: State, { id }: { id: string }): State {
  return {
    ...state,
    list: state.list.filter((item: Milestone) => item.id !== id),
  };
}

function replaceMilestone(state: State, { data }: { data: Milestone }): State {
  const index = state.list.findIndex((item: Milestone) => item.id === data.id);
  if (index === -1) {
    return state;
  }

  const newList = [...state.list];
  newList[index] = data;

  return {
    ...state,
    list: newList,
  };
}
